<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <create-role
      v-if="showCreateRoleDialog"
      @closed="showCreateRoleDialog=false"
    />
    <edit-role-permissions
      v-if="showAddPermissionsDialog"
      :roleid="roleId"
      :existingpermissions="existingpermissions"
      @closed="showAddPermissionsDialog=false"
    />
    <assigned-permissions-list
      v-if="showAssignedPermissionsList"
      :assignedpermissionslist="assignedPermissionsList"
      :groupname="permissionGroupName"
      :pageheader="pageHeader"
      @closed="showAssignedPermissionsList = false"
    />
    <br>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <v-col
        cols="12"
        class="text-right"
      >
        <v-btn
          color="#FF3700"
          @click=" CreateRole()"
        >
          <v-icon
            left
            dark
          >
            mdi-plus
          </v-icon>
          Role
        </v-btn>
      </v-col>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              label="Search"
              append-icon="mdi-magnify"
              outlined
              dense
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-toolbar
        flat
        color="#ECEFF1"
      >
        <v-toolbar-title class="my-toolbar-style">
          Roles List
        </v-toolbar-title>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="rolesAndPermissionsList "
        :search="search"
        class="elevation-1"
      >
        <template
          #item="{ item }"
        >
          <tr>
            <td>
              {{ item.name }}
            </td>
            <td>
              <v-btn
                v-if="item.permissions.length !== 0"
                text
                class="button-style"
                @click="viewAssignedPermissionsList(item.permissions, item.name)"
              >
                <v-icon left>
                  mdi-eye
                </v-icon>
                View
              </v-btn>
              <p v-else>
                N/A
              </p>
            </td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                color="#37474F"
                x-small
                icon
                @click="showAddPermissionsform(item.id, item.permissions)"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#C62828"
                @click="deleteRole()"
              >
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="py-3" />
      <centre-spinner
        :loading="loading"
      />
    </v-card>
  </v-container>
</template>

<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import CreateRole from 'src/views/dashboard/settings/CreateRole.vue';
  import EditRolePermissions from 'src/views/dashboard/settings/EditRolePermissions.vue';
  import AssignedPermissionsList from 'src/views/dashboard/settings/AssignedPermissionsList.vue';
  import Constants from 'src/constants';
  export default {
    name: 'RolesList',
    components: {
      'create-role': CreateRole,
      'centre-spinner': spinner,
      'edit-role-permissions': EditRolePermissions,
      'assigned-permissions-list': AssignedPermissionsList,
    },
    data () {
      return {
        search: '',
        loading: false,
        headers: [
          { text: 'Roles', align: 'start', value: 'name' },
          { text: 'Permissions', value: 'Permissions' },
          { text: 'Add Permissions', value: 'edit' },
          { text: 'Delete', value: 'delete' },
        ],
        showCreateRoleDialog: false,
        showAddPermissionsDialog: false,
        roleId: '',
        existingpermissions: [],
        showAssignedPermissionsList: false,
        assignedPermissionsList: [],
        permissionGroupName: '',
        pageHeader: '',
      };
    },
    computed: {
      rolesAndPermissionsList () {
        return this.$store.getters['accountcontrol/getRolesAndPermissionsList'];
      },
    },
    mounted () {
      this.getRolesAndPermissions();
    },
    methods: {
      CreateRole () {
        this.showCreateRoleDialog = true;
      },
      showAddPermissionsform (roleId, existingpermissions) {
        this.roleId = roleId;
        this.existingpermissions = existingpermissions;
        this.showAddPermissionsDialog = true;
      },
      async getRolesAndPermissions () {
        this.loading = true;
        await this.$store.dispatch('accountcontrol/fetchRolesAndPermissionsList');
        this.loading = false;
      },
      deleteRole () {
        this.$store.dispatch('alert/onAlert', {
          message: 'You are not authorized to delete a role from the list.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
      },
      viewAssignedPermissionsList (assignedPermissionsList, permissionGroupName) {
        this.assignedPermissionsList = assignedPermissionsList;
        this.permissionGroupName = permissionGroupName;
        this.pageHeader = 'Assigned Permissions';
        this.showAssignedPermissionsList = true;
      },
    },
  };
</script>
<style scoped>
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.font-my-style {
  font-weight: bold;
}
.v-data-table { background-color: #ECEFF1; }
.title-style {
  color: #37474F;
}
.my-toolbar-style {
  color: #37474F;
  font-weight: bold;
}
.button-style {
  font-weight: bold;
  color: #37474F;
}
</style>
